export const DEG90 = Math.PI * 0.5;
export const DEG180 = Math.PI;

export type Side = 'front' | 'back' | 'up' | 'down' | 'left' | 'right';

export function rotateTo(side: Side): { azimuth: number; polar: number } {
    switch (side) {
        case 'front':
            return { azimuth: 0, polar: DEG90 };
        case 'back':
            return { azimuth: DEG180, polar: DEG90 };
        case 'up':
            return { azimuth: 0, polar: 0 };
        case 'down':
            return { azimuth: 0, polar: DEG180 };
        case 'left':
            return { azimuth: -DEG90, polar: DEG90 };
        case 'right':
            return { azimuth: DEG90, polar: DEG90 };
        default:
            return { azimuth: 0, polar: DEG90 };
    }
}

export interface CameraPadding {
    top: number;
    right: number;
    bottom: number;
    left: number;
}

export function paddingInCssPixel(top: number, right: number, bottom: number, left: number): CameraPadding {
    return { top, right, bottom, left };
}
